import mondaySdk from 'monday-sdk-js'
import { utilsService } from './utils.Service'
const monday = mondaySdk()
monday.setApiVersion('2025-07')


const getBoards = async (workspaceId, isShowCurrWorkspace, userId) => {
  try {
    const boards = []
    const limit = 3000
    let res
    let pageIdx = 1

    if (isShowCurrWorkspace) {
      const query = `query{
          boards(limit:${limit}, workspace_ids: ${workspaceId}){
            id
            name
            type
            permissions
            owners {
              id
            }
          }
        }`

      res = await queryData(query)
      boards.push(...res.boards)
    } else {
      const query = `query{
          boards(limit:${limit}, page:${pageIdx}) {
            id
            name
            type
            permissions
            owners {
              id
            }            
          }
        }`
      res = await queryData(query)
      boards.push(...res.boards)

      while (!res || res.boards.length === limit) {
        const query = `{
        boards (limit:${limit}, page:${pageIdx}) {
            name
            id
            type
            permissions
            owners {
              id
            }           
         }
        }`
        res = await queryData(query)
        boards.push(...res.boards)
        pageIdx++
      }
    }
    const mappedBoards = boards
      .filter((board) => board.type !== 'sub_items_board' && board.type !== 'document')
      .map((board) => {
        const isOwner = board.owners.some(owner => +owner.id === +userId)
        return { value: board.id, label: board.name, permissions: board.permissions, isOwner }
      })

    return mappedBoards
  } catch (err) {
    console.log('file: mondayService.js:65 -> err:', err)
  }
}

const filterBoardsByWorkspace = async (workspaceId, boardRelations, monday) => {
  const query = `query{
      boards(workspace_ids: ${workspaceId}, limit: 3000){
        id
      }
    }`
  const res = await queryData(query)

  const boardsIds = res.boards.map((board) => board.id)
  const filteredRelations = boardRelations.filter((relation) => {
    return boardsIds.includes(relation.mainBoard.board.value.toString())
  })
  return filteredRelations
}

const getSlug = async (userId, setUserEmail, setUserDomain, monday) => {
  const query = `
    query{
      users(ids:${userId}){
        email
        url
        account {
          slug
        }
      }
    }`
  const res = await queryData(query)
  setUserEmail(res.users[0].email)
  setUserDomain(res.users[0].url.split('//')[1].split('/')[0])
}

const getFoldersData = async (folderIds) => {
  const colors = {
    DONE_GREEN: '#05ca71',
    BRIGHT_GREEN: '#9dd525',
    WORKING_ORANGE: '#fbab3e',
    DARK_ORANGE: '#ff642d',
    SUNSET: '#ff7576',
    STUCK_RED: '#e2435b',
    DARK_RED: '#ba3353',
    SOFIA_PINK: '#fc2491',
    LIPSTICK: '#f17af2',
    PURPLE: '#a662dd',
    DARK_PURPLE: '#784bd1',
    INDIGO: '#5659df',
    BRIGHT_BLUE: '#579bfb',
    AQUAMARINE: '#4eccc6',
    CHILI_BLUE: '#65ccff'
  }

  const queryFolderData = `{
    folders(ids:[${folderIds}]) {
      color
      name
      id
    }
  }`

  try {
    const resFolderData = await queryData(queryFolderData)

    const folders = resFolderData.folders.reduce((acc, folder) => {
      acc[folder.id] = {
        id: folder.id,
        name: folder.name,
        color: folder.color ? colors[folder.color] : '#f1f3fa'
      }
      return acc
    }, {})

    return folders

  } catch (err) {
    console.log("file: mondayService: 126 -> err: ", err)
    throw err
  }
}

const getBoardsDataForTree = async (boardsIds) => {
  try {
    const query = `{
      boards(ids: [${boardsIds}]) {
       id
       name
       groups {
         title
         color
         id
       }
       items_page(limit: 500) {
         items {
           id
           name
           group {
           id
           }
         }
       }
     }
    }`

    const res = await queryData(query)

    return res.boards
  } catch (err) {
    // console.log("file: mondayService: 164 -> err: ", err)
    throw err
  }
}


//groups tree
const getHeadBoard = async (boardIds, connectBoardIds, itemIds) => {
  try {
    const query = `
    {
      boards(ids: [${boardIds}]) {
        id
        name
        groups {
          title
          color
          id
        }
        columns(ids: "${connectBoardIds.join("\",\"")}") {
          settings_str
        }
        items_page(limit: 500, query_params: {ids: [${itemIds}]}) {
          items {
            id
            name
            group {
              id
            }
            column_values(ids: "${connectBoardIds.join("\",\"")}") {          
              ... on BoardRelationValue {
                linked_item_ids
              }
            }
          }
        }
      }
    }
    `
    const res = await queryData(query)

    return res.boards

  } catch (err) {
    console.log("file: mondayService: 187 -> err: ", err)
    throw err
  }
}

export const mondayService = {
  getBoards,
  filterBoardsByWorkspace,
  getSlug,
  getFoldersData,
  getBoardsDataForTree,
  getFormulaColValue,
  getColumnData,
  getFirstItemIdInGroup,
  getHeadBoard
}

// utils

async function queryData(query) {
  try {
    const res = await monday.api(query)

    if (!res.data || res?.error_code || res?.status_code === 500) {
      throw new Error(res?.error_message || "Error fetching data")
    }

    return res.data
  } catch (err) {
    console.log('file: mondayService.js:19 -> err:', err.data)
    const complexityError = err?.data?.errors?.find(e => e?.extensions?.code === "COMPLEXITY_BUDGET_EXHAUSTED")

    if (complexityError) {
      const res = await _handleComplexityError(complexityError, query)
      return res
    } else console.log('file: monday-service.ts:26 -> query:', query)

    throw err
  }
}

async function _handleComplexityError(complexityError, query) {
  const retryInSeconds = complexityError?.extensions?.retry_in_seconds;
  // Wait for the specified time and retry the query
  await utilsService.sleep(+retryInSeconds * 1000);
  return await queryData(query);
}

async function getFormulaColValue(boardId, itemId, formulaColId) {
  try {
    const query = `
    {
      boards(ids: ${boardId}) {
        items_page(query_params: {ids: ${itemId}}) {
          items {
            column_values(ids: "${formulaColId}") {
              ... on FormulaValue {
                display_value
              }
            }
          }
        }
      }
    }
    `
    const res = await queryData(query)
    return res.boards[0].items_page.items[0].column_values[0].display_value
  } catch (err) {
    console.log("file: mondayService: 236 -> err: ", err)
    throw err
  }
}

async function getColumnData(boardsIds, columnsIds) {
  try {
    const query = `{
                    boards(ids: [${boardsIds}]) { 
                      id
                      columns(ids: ["${columnsIds.join("\",\"")}"]) { 
                        id 
                        type 
                        settings_str 
                      } 
                    }
                   } `
    const res = await queryData(query)
    return res.boards
  } catch (err) {
    console.log("file: mondayService: 388 -> err: ", err)
    throw err
  }
}

async function getFirstItemIdInGroup(boardId, groupId) {
  try {
    const query = `
    {
      boards(ids: ${boardId}) {
        groups(ids: "${groupId}") {
          items_page(limit: 1) {
            items {
              id
            }
          }
        }
      }
    }
    `
    const res = await queryData(query)
    return res.boards[0].groups[0].items_page.items[0]?.id

  } catch (err) {
    console.log("file: mondayService: 271 -> err: ", err)
    throw err
  }
}